import {
  apiGET,
  apiPOST
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/casino.ts
var getCasinoProviderToken = async (provider) => {
  return await apiGET(`/casino/provider/${provider}/token`, null, {
    hasNestedData: false
  });
};
var getCasinoDirectIntegrationUrl = async (isDemo, body) => {
  const gameType = isDemo ? "demo-game" : "game";
  return await apiPOST(`/casino/api/${gameType}/url`, body, {
    hasNestedData: false
  });
};
var getCasinoProviderUrl = async (allQueryParams) => {
  return await apiGET(allQueryParams, null, { hasNestedData: false });
};

export {
  getCasinoProviderToken,
  getCasinoDirectIntegrationUrl,
  getCasinoProviderUrl
};
